import { render, staticRenderFns } from "./BaseTextRow.vue?vue&type=template&id=80da8af2&"
import script from "./BaseTextRow.vue?vue&type=script&lang=js&"
export * from "./BaseTextRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports